import { render, staticRenderFns } from "./board-column-drag-list.vue?vue&type=template&id=0e0b289e&"
import script from "./board-column-drag-list.vue?vue&type=script&lang=js&"
export * from "./board-column-drag-list.vue?vue&type=script&lang=js&"
import style0 from "./board-column-drag-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports